export type ILocale =
  | "en-US"
  | "en-GB"
  | "en-AU"
  | "en-AT"
  | "en-CH"
  | "en-IE"
  | "en-SG"
  | "en-MY"
  | "es-ES"
  | "en-DE"
  | "fr-FR"
  | "de-DE"
  | "ja-JP"
  | "he-IL"
  | "cz-CZ";

export const countryCallingCodes: Record<ILocale, string> = {
  "en-US": "1", // United States
  "en-GB": "44", // United Kingdom
  "en-AU": "61", // Australia
  "en-AT": "43", // Austria
  "en-CH": "41", // Switzerland
  "en-IE": "353", // Ireland
  "es-ES": "34", // Spain
  "fr-FR": "33", // France
  "en-DE": "49", // English (Germany)
  "de-DE": "49", // Germany
  "ja-JP": "81", // Japan
  "he-IL": "972", // Israel
  "cz-CZ": "420", // Czechia
  "en-MY": "60", // Malaysia
  "en-SG": "65", // Singapore
};

// Maps a detected ISO country code (from `x-user-country`) to its `countryLabels`
// i18n key. Covers every VELYS-supported country (US, ANZ, EMEA, SEA).
export const countryLabelKeys: Record<string, string> = {
  US: "unitedStates",
  GB: "unitedKingdom",
  AU: "australia",
  AT: "austria",
  CH: "switzerland",
  DE: "germany",
  IE: "ireland",
  SG: "singapore",
  MY: "malaysia",
};

export const SUPPORTED_LOCALES = [
  { value: "en-US", name: "English (US)" },
  { value: "en-GB", name: "English (UK)" },
  { value: "en-AU", name: "English (AU)" },
  { value: "en-AT", name: "English (AT)" },
  { value: "en-CH", name: "English (CH)" },
  { value: "en-IE", name: "English (Ireland)" },
  { value: "en-DE", name: "English (Germany)" },
  { value: "en-SG", name: "English (Singapore)" },
  { value: "en-MY", name: "English (Malaysia)" },
  { value: "de-DE", name: "German (Germany)" },
  // { value: "it-IT", name: "Italian (Italy)" },
  // { value: "fr-FR", name: "French (France)" },
  // { value: "he-IL", name: "Hebrew (Israel)" },
  // { value: "cz-CZ", name: "Czech (Czechia)" }
];
